module.exports = __webpack_public_path__ + "img/TPrimary.7a124ea6.png";